import apiUrl from 'common/api-url';
import { xhr } from 'common/xhr';

export const fetchQuote = (quoteId: number) => xhr.getWithPromise(apiUrl('POS_QUOTE', { quoteId }));

export const voidQuote = (quoteId: number, employeeId?: number) =>
  xhr.doJQueryAjax({
    type: 'PATCH',
    url: apiUrl('POS_VOID_QUOTE', { quoteId }),
    data: JSON.stringify({
      employeeId,
      authenticatedEmployeeId: employeeId,
    }),
    contentType: 'application/json',
  });
